import React from 'react';
import Fun2025 from 'views/Fun2025';

const LifeSkillPage = () => {
  return <Fun2025/>;
};

export default LifeSkillPage;
